<div class="import-order__main-content">
	<div class="import-select__content">
		<div class="select-to-import-option">
			<label class="select-lbl">Form</label>
			<cv-dropdown
				[options]="formList$ | async"
				[placeholder]="'Select a form'"
				[optionText]="'displayText'"
				[width]="'100%'"
				(valuesChange)="onFormSelectChange($event)"
			></cv-dropdown>
		</div>
		<div class="select-to-import-option">
			<label class="select-lbl">App</label>
			<cv-dropdown
				[options]="appList$ | async"
				[placeholder]="'Select an app'"
				[optionText]="'displayName'"
				(valuesChange)="onAppSelectChange($event)"
				[width]="'100%'"
			></cv-dropdown>
		</div>
		<div class="select-to-import-option">
			<cv-input
				[label]="getAppraisalNumberLabel(importForm.paramName)"
				[type]="'number'"
				[min]="1"
				[name]="'appraisal'"
				[placeholder]="'Add a number'"
				[value]="importForm.number"
				(controlKeyup)="onAppraisalChange($event)"
			></cv-input>
		</div>
	</div>
	<div class="import-select__content">
		<div class="import-option__btn">
			<button
				[disabled]="
					importForm.form === null ||
					importForm.app === null ||
					importForm.number === null ||
					!btnEnable
				"
				class="btn btn-sm btn-primary"
				(click)="onSubmitOrder()"
			>
				Submit order <i class="fas fa-upload"></i>
			</button>
		</div>
	</div>
	<hr class="separator" />
	<ag-grid-angular
		class="ag-theme-balham"
		*ngIf="isGridReady"
		#importGrid
		(gridReady)="onInitializeGrid($event)"
		(gridSizeChanged)="resizeToFitColumns()"
		[pagination]="true"
		[suppressPaginationPanel]="true"
		[gridOptions]="gridOptions"
		[domLayout]="'autoHeight'"
		[rowData]="gridData | async"
	>
	</ag-grid-angular>
	<cv-grid-pagination
		*ngIf="isGridReady"
		[pagination]="pagination"
		(onPaginationChange)="onPaginationChange($event)"
	></cv-grid-pagination>
</div>
<cv-confirmation-import-modal></cv-confirmation-import-modal>
